import client from './client';

// Tệp của chat KHÁCH HÀNG đi lên MEDIA SERVER dùng chung, KHÁC với chat nội bộ (vẫn nằm ở
// /uploads của FunnyTask — xem uploadChatFiles trong api/chat.js).
// Lý do: tệp này khách bên bidnhanh (web + app) phải xem được. Để ở FunnyTask thì url chỉ
// sống khi FunnyTask còn chạy; đưa lên kho dùng chung thì tệp độc lập với cả hai hệ.
//
// KHÔNG có đường lùi về /chat/upload: media hỏng thì BÁO LỖI, không gửi tin. Lùi âm thầm sẽ
// đẩy tệp vào kho riêng của FunnyTask — vẫn hiện được, nhưng mất đúng tính chất ta cần, và
// hỏng cấu hình sẽ không ai phát hiện cho tới lúc đã có hàng nghìn tệp nằm sai chỗ.
export const uploadCustomerChatFiles = async (files) => {
  // Bước 1 — xin vé ở backend FunnyTask.
  let t;
  try {
    const res = await client.get('/chat/upload-ticket');
    t = res.data || {};
  } catch (e) {
    if (e?.response?.status === 503) {
      throw new Error('Máy chủ ảnh chưa được cấu hình. Vui lòng báo quản trị viên.');
    }
    throw new Error('Không lấy được quyền tải tệp lên. Thử lại sau ít phút.');
  }
  if (!t.ticket || !t.mediaBase) {
    throw new Error('Máy chủ ảnh chưa được cấu hình. Vui lòng báo quản trị viên.');
  }

  // Bước 2 — đẩy tệp thẳng lên media server.
  const fd = new FormData();
  [...files].forEach((f) => fd.append('files', f));

  let r;
  try {
    r = await fetch(`${t.mediaBase}/v1/upload`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${t.ticket}` },
      body: fd,
    });
  } catch (e) {
    // fetch chỉ ném khi KHÔNG tới được máy chủ (tắt, sai địa chỉ, CORS chặn).
    console.error('[custchat] không kết nối được media server:', t.mediaBase, e.message);
    throw new Error('Không kết nối được máy chủ ảnh. Kiểm tra mạng rồi thử lại.');
  }

  if (!r.ok) {
    const body = await r.json().catch(() => ({}));
    console.error('[custchat] media server từ chối:', r.status, body);
    if (r.status === 401) throw new Error('Phiên tải tệp đã hết hạn. Thử gửi lại.');
    throw new Error(body.message || `Máy chủ ảnh báo lỗi (${r.status}).`);
  }

  // Bước 3 — từng tệp có thể đạt hoặc bị từ chối riêng.
  const json = await r.json().catch(() => ({}));
  const all = json.files || [];
  const ok = all.filter((f) => !f.error);
  const bad = all.filter((f) => f.error);

  if (!ok.length) throw new Error(bad[0]?.message || 'Tải tệp lên thất bại.');
  // Có tệp hỏng lẫn tệp tốt: KHÔNG gửi nửa vời — người dùng tưởng đã gửi đủ.
  if (bad.length) throw new Error(`${bad[0].name || 'Một tệp'}: ${bad[0].message || 'không hợp lệ'}`);
  return ok;
};

// Ngưỡng đánh dấu sao KH (chỉ GĐ): xem + đặt.
export const getStarConfig = () => client.get('/customer-chat/star-config').then((r) => r.data);
export const setStarConfig = (mhThreshold, vcThreshold) => client.put('/customer-chat/star-config', { mhThreshold, vcThreshold }).then((r) => r.data);

// Trợ lý đơn hàng tự động (chỉ GĐ): bật/tắt + chọn kênh áp dụng (rỗng = mọi kênh).
export const getBotConfig = () => client.get('/customer-chat/bot-config').then((r) => r.data);
export const setBotConfig = (payload) => client.put('/customer-chat/bot-config', payload).then((r) => r.data);

// Chat KHÁCH HÀNG ↔ NV (nguồn bidnhanh, đổ vào qua webhook).
export const listCustConversations = () => client.get('/customer-chat/conversations').then((r) => r.data);
export const listCustMessages = (id, params = {}) => client.get(`/customer-chat/conversations/${id}/messages`, { params }).then((r) => r.data);
export const sendCustReply = (id, text, extra = {}) =>
  client.post(`/customer-chat/conversations/${id}/messages`, { text, ...extra }).then((r) => r.data);
export const custMarkRead = (id) => client.post(`/customer-chat/conversations/${id}/read`).then((r) => r.data);
export const custMarkUnread = (id) => client.post(`/customer-chat/conversations/${id}/unread`).then((r) => r.data);
export const custHide = (id) => client.post(`/customer-chat/conversations/${id}/hide`).then((r) => r.data);
export const custMute = (id, muted) => client.post(`/customer-chat/conversations/${id}/mute`, { muted }).then((r) => r.data);
// (TP/GĐ) TẮT/BẬT âm TOÀN BỘ tin khách — vẫn xem tin trong app, chỉ ngừng thông báo đẩy.
export const custMuteAll = (muted) => client.post('/customer-chat/mute-all', { muted }).then((r) => r.data);
// TẮT/BẬT thông báo hệ thống theo TỪNG LUỒNG (kd/cskh/dvkh) — trả { mutedSvc: [...] } mới.
export const custMuteChannel = (svcType, muted) => client.post('/customer-chat/mute-channel', { svcType, muted }).then((r) => r.data);
export const custReact = (messageId, emoji) => client.post(`/customer-chat/messages/${messageId}/react`, { emoji }).then((r) => r.data);
// GỬI LẠI 1 tin đã lưu nhưng gửi lỗi — đẩy lại ĐÚNG tin cũ (không đẻ tin mới) nên khách không nhận trùng.
export const custRetryMessage = (convId, msgId) => client.post(`/customer-chat/conversations/${convId}/messages/${msgId}/retry`).then((r) => r.data);
// NV THU HỒI tin đã gửi KH (trong 10'): server xoá nội dung, hiện "Tin nhắn đã được thu hồi" + báo 3dfreezy gỡ.
export const custRecallMessage = (convId, msgId) => client.post(`/customer-chat/conversations/${convId}/messages/${msgId}/recall`).then((r) => r.data);
// Trang Tin nhắn: kho ảnh/tệp + tìm chữ trong 1 hội thoại KH.
export const custListMedia = (id) => client.get(`/customer-chat/conversations/${id}/media`).then((r) => r.data);
// Liên kết (URL) đã gửi trong hội thoại KH — tab "Link" của Kho lưu trữ.
export const custListLinks = (id) => client.get(`/customer-chat/conversations/${id}/links`).then((r) => r.data);
export const custSearchMessages = (id, q) =>
  client.get(`/customer-chat/conversations/${id}/search`, { params: { q } }).then((r) => r.data);
// Tìm NỘI DUNG tin nhắn KH trên mọi hội thoại trong phạm vi của mình (kiểu FB).
export const custSearchAllMessages = (q) => client.get('/customer-chat/search', { params: { q } }).then((r) => r.data);
// Ghim HỘI THOẠI KH lên đầu danh sách (riêng từng người, tối đa 3).
export const custPinConversation = (id, pinned) => client.post(`/customer-chat/conversations/${id}/pin`, { pinned }).then((r) => r.data);
// CÔNG VIỆC trong chat KH (chỉ nhân viên thấy): tạo / tiếp nhận / hoàn thành-mở lại / xoá.
export const createCustTask = (convId, payload) => client.post(`/customer-chat/conversations/${convId}/tasks`, payload).then((r) => r.data);
export const acceptCustTask = (convId, taskId) => client.post(`/customer-chat/conversations/${convId}/tasks/${taskId}/accept`).then((r) => r.data);
export const completeCustTask = (convId, taskId, done = true) => client.patch(`/customer-chat/conversations/${convId}/tasks/${taskId}`, { done }).then((r) => r.data);
export const deleteCustTask = (convId, taskId) => client.delete(`/customer-chat/conversations/${convId}/tasks/${taskId}`).then((r) => r.data);
// CHỦ ĐỘNG mở hội thoại nhắn KH (không chờ KH nhắn trước). KH đã có luồng -> trả luồng cũ.
// svcType (kd/cskh/dvkh) tuỳ chọn — NV chọn kênh nhắn; bỏ trống -> BE mặc định theo phòng của NV.
export const createCustConversation = (custCode, svcType, source) =>
  client.post('/customer-chat/conversations', { custCode, svcType, source }).then((r) => r.data);
// Kênh NV được nhắn KH (để hiện ô chọn kênh khi NV có >1 kênh).
export const getMyChannels = () => client.get('/customer-chat/my-channels').then((r) => r.data.channels || []);
